// import * as types from '../mutation-type'
import service from '@/services'
// import { storage } from '@/utils'

// getters
const getters = {

}

// actions
const actions = {
  queryInformationList: ({commit}, payload) => {
    return service.queryInformationList(commit, payload)
  },
  queryPartnerList: ({commit}, payload) => {
    return service.queryPartnerList(commit, payload)
  },
  applypage: ({commit}, payload) => {
    return service.applypage(commit, payload)
  },
  authenticationsuccess: ({commit}, payload) => {
    return service.authenticationsuccess(commit, payload)
  },
  applyquery: ({commit}, payload) => {
    return service.applyquery(commit, payload)
  },
  applyauthenticationsuccess: ({commit}, payload) => {
    return service.applyauthenticationsuccess(commit, payload)
  },
  applyauthenticationfailed: ({commit}, payload) => {
    return service.applyauthenticationfailed(commit, payload)
  },
  queryToShow: ({commit}, payload) => {
    return service.queryToShow(commit, payload)
  },
  productQueryPageToShow: ({commit}, payload) => {
    return service.productQueryPageToShow(commit, payload)
  },
  partnerQueryPageToShow: ({commit}, payload) => {
    return service.partnerQueryPageToShow(commit, payload)
  },
  atlassQueryPageToShow: ({commit}, payload) => {
    return service.atlassQueryPageToShow(commit, payload)
  },
  partnerAuthenticationsuccess: ({commit}, payload) => {
    return service.partnerAuthenticationsuccess(commit, payload)
  },
  partnerAuthenticationfailed: ({commit}, payload) => {
    return service.partnerAuthenticationfailed(commit, payload)
  },
  updateCustomer: ({commit}, payload) => {
    return service.updateCustomer(commit, payload)
  },
  productAuthenticationsuccess: ({commit}, payload) => {
    return service.productAuthenticationsuccess(commit, payload)
  },
  productAuthenticationfailed: ({commit}, payload) => {
    return service.productAuthenticationfailed(commit, payload)
  },
  informationLabel: ({commit}, payload) => {
    return service.informationLabel(commit, payload)
  },
  queryInformationDetail: ({commit}, payload) => {
    return service.queryInformationDetail(commit, payload)
  },
  informationDelete: ({commit}, payload) => {
    return service.informationDelete(commit, payload)
  },
  informationAuthenticationfailed: ({commit}, payload) => {
    return service.informationAuthenticationfailed(commit, payload)
  }
}

// mutations
const mutations = {

}

export default {
//   state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/audit.js